import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  spinnerScreenReaderText: {
    id: 'authoring.videoEditor.spinnerScreenReaderText',
    defaultMessage: 'cargando',
    description: 'Mensaje de carga para el lector de pantalla del spinner.',
  },
  replaceVideoButtonLabel: {
    id: 'authoring.videoEditor.replaceVideoButtonLabel',
    defaultMessage: 'Reemplazar video',
    description: 'Texto del botón para reemplazar el video y volver a la galería de videos',
  },
});

export default messages;
